import VuexPersistence from "vuex-persist";
import { createStore } from "vuex";
import analytics from "./modules/analytics";
import announcements from "./modules/announcements";
import auth from "./modules/auth";
import billingEntities from "./modules/billingEntities";
import cable from "./modules/cable";
import contractDistributions from "@/store/modules/contractDistributions";
import claims from "@/store/modules/claims";
import leads from "@/store/modules/leads";
import matchedContracts from "@/store/modules/matchedContracts";
import merchantProfiles from "@/store/modules/merchantProfiles";
import notifications from "./modules/notifications";
import organization from "./modules/organization";
import retributionConfigurations from "@/store/modules/retributionConfigurations";
import sellers from "./modules/sellers";
import store from "./modules/store";
import retributions from "./modules/retributions";
import businessVerticals from "./modules/businessVerticals";
import cancellations from "./modules/cancellations";
import challenge from "./modules/challenge";
import grossSales from "./modules/grossSales";
import invoices from "./modules/invoices";
import products from "@/store/modules/products";
import planSales from "@/store/modules/planSales";
import quizzes from "./modules/quizzes";
import trainingModules from "./modules/trainingModules";

const vuexLocal = new VuexPersistence({
  key: "vuex_store",
  storage: window.localStorage,
  // Announcements are fetched at each visit: a persisted copy would show outdated ones before the API answers
  reducer: (state) => Object.fromEntries(Object.entries(state).filter(([module]) => module !== "announcements")),
});

export default createStore({
  modules: {
    analytics,
    announcements,
    auth,
    billingEntities,
    cable,
    contractDistributions,
    claims,
    leads,
    matchedContracts,
    merchantProfiles,
    notifications,
    organization,
    planSales,
    retributionConfigurations,
    sellers,
    store,
    retributions,
    businessVerticals,
    cancellations,
    challenge,
    grossSales,
    invoices,
    products,
    quizzes,
    trainingModules,
  },
  plugins: [vuexLocal.plugin],
});
